import React, { useEffect, useState } from "react";
import { Link } from "@StarberryUtils"
import noImage from "../../../images/no-image.png"
import { Container } from 'react-bootstrap';
import FsLightbox from 'fslightbox-react';
import './PropertyDetailsBanner.scss';
import ScrollAnimation from 'react-animate-on-scroll';
import Slider from 'react-slick';
import $ from "jquery";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageRenderer from "../../ImageRenderer/ImageRenderer"
import FloorPlanModalDetails from "../FloorPlanModalDetails/floorPlanModalDetails";
import VirtualTourModalDetails from "../VirtualTourModalDetails/virtualTourModalDetails";

const PropertyDetailsBanner = (props) => {

  const [indexed, setIndex] = useState(1)

  const [toggler, setToggler] = useState(false);

  const settings = {
    dots: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: "slick"
      },
      {
        breakpoint: 991,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        infinite: true,
        arrows: true,
        centerPadding: '0px',

      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        }
      }
    ]
  }

  const afterChangeHandler = (d) => {
    setIndex(d + 1)
  }

  // console.log("images------", props.property_floorplan_image[0].url)

  useEffect(() => {
    $(".banner_map").click(function () {
      $('html, body').animate({
        scrollTop: $(".property-map").offset().top - 10
      }, 1000);
    });
  }, []);
  let lightBox = [];
  if (props.property_details_images && (props.property_details_images.length > 0)) {
    props.property_details_images.map(item => {
      let image = item.srcUrl
      if (item.url) {
        image = item.url
      }
      lightBox.push(image)
    })
  }


  return (
    <div className="property-details-banner d-xl-flex">
      <div className="banner-img1">
        {props.property_details_images && (props.property_details_images.length > 0) ?
          <Slider {...settings}
            afterChange={
              v => afterChangeHandler(v)
            }
          >
            {
              props.property_details_images.map(slideritem => {

                return <>
                  <div className="">
                    <ImageRenderer ImageSrc={slideritem} altText={props.property_details_image_title + ' - Bentley Hurst'} ggfx_results={props.ggfx_results} strapi_id={props.property_details_image_id} imagename="property.images.propertyDetails_1" />
                  </div>
                </>
              })
            }
            {/* <div className="d-none d-md-block d-lg-none">
              <ImageTransform 
                imagesources={props.property_details_images.length > 0 ? props.property_details_images[1].url : ''}
                renderer="srcSet" 
                imagename="property.images.propertyDetails_1" 
                attr={{ alt: props.property_details_image_title+ ' - Bentley Hurst', class:'' }} 
                imagetransformresult={props.property_processedImages}
                id={props.property_details_image_id}
              />
            </div> */}

          </Slider>
          :
          <img src={noImage} className="no-image-property" alt="" />
        }
      </div>
      {
        props.property_details_images && (props.property_details_images.length > 0) ?
          <Container className="tags-container d-none d-md-block">
            <ScrollAnimation animateIn='fadeIn' animateOnce={true} delay={500}>
              <Link to="#" onClick={() => setToggler(!toggler)} className="tag zoom d-none d-xl-inline-block"><i className="zoom-icon"></i></Link>
              <span className="tag">{indexed} / {props.property_details_images.length} Photos</span>
              {props?.property_virtual_tour?.length > 0 ?
                <VirtualTourModalDetails videourl={props.property_virtual_tour[0]} icon={''} />
                : ''}
              <a href="javascript:void(0)" className="tag banner_map">Map</a>
              {props.property_floorplan_image.length > 0 ?
                <FloorPlanModalDetails floorplanimg={props.property_floorplan_image[0].url} icon={''} />
                : ''}
            </ScrollAnimation>
          </Container>
          : ''
      }

      {/* Property Images */}
      <FsLightbox
        toggler={toggler}
        sources={lightBox}
        type='image'
      />
      {/* Property Images */}

      <div className="banner-img2 d-none d-xl-block">
        <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
          {props.property_details_images.length > 1 ?
            <ImageRenderer ImageSrc={props.property_details_images[1]} altText={props.property_details_image_title + ' - Bentley Hurst'} ggfx_results={props.ggfx_results} strapi_id={props.property_details_image_id} imagename="property.images.lightbox" />
            :
            <img src={noImage} className="no-image-property" alt="" />
          }
        </ScrollAnimation>
      </div>
    </div>
  )
}

export default PropertyDetailsBanner